import { render, staticRenderFns } from "./index.vue?vue&type=template&id=be2101c6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=be2101c6&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=be2101c6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be2101c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be2101c6')) {
      api.createRecord('be2101c6', component.options)
    } else {
      api.reload('be2101c6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=be2101c6&scoped=true", function () {
      api.rerender('be2101c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ik/table/ikColumn/IkColumnNumber/index.vue"
export default component.exports